exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=\"text\"] { text-align:center; margin:0 0 5px 0; }\r\nform { /* max-height:400px;\toverflow:auto; */ padding:20px 0; }\r\n.input-field { margin-top:0; }\r\n.input-field a { padding:0px 0; display:inline-block; }\r\n.divider { margin:20px 0; }\r\n.label-list { padding:20px; }\r\n.print-label{display:none;}\r\n@media print {\r\n    /* invert the display (show/hide) properties of the main */\r\n    /* aplication component and the printing component       */\r\n  \r\n    .print-label {\r\n      display: block;\r\n    }\r\n  \r\n    .printmodal {\r\n      display: none;\r\n    }\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-invoices/shipping-info/shipping-info.component.css
// module id = ../../../../../src/app/mnt-invoices/shipping-info/shipping-info.component.css
// module chunks = common